import React from "react";
import throttle from "lodash/throttle";
import { Toast } from "antd-mobile";
import * as Api from "../../utils/api";
import Base64 from "crypto-js/enc-base64";
import HmacSha256 from "crypto-js/hmac-sha256";
import Http from "../../utils/http";
import Utils from "../../utils/utils";

import CommonNav from "../../components/goBack";

let HttpInstance = new Http();
const utils = new Utils();
let iconCouponSelect = require("../../assets/images/icon_select.png");
let iconCouponSelected = require("../../assets/images/icon_coupon_selected.png");
let iconDragonSelect = require("../../assets/images/dragon_select.png");
let iconDragonSelected = require("../../assets/images/dragon_selected.png");

export default class OrderPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      userInfo: {},
      isUseDragon: true,
      scaleH: 0,
      courseID: "",
      courseInfo: {
        courseID: "",
        experter: "高培毅",
        experterIns:
          "中国放射科宗师级医生,放射科信息化奠基人，本节课是一节实践性很强的应用科学专业。它致力于培养具备基础医学、临床医学的基本理论和医疗玉芳XXXXXXXXX",
        name: "放射科医生PET-CT初步诊断快速入门及进阶",
      },
      couponList: [],
      dragonInfo: {},
      couponText: "暂无可用优惠券",
      shouldPayMoney: 0,
      discountPrice: {},
      currentCoupon: {},
      isShowPayMoney: false,
      isShowCoupnDiscount: false,
      isVip: false,
    };
  }
  render() {
    const _this = this;
    return (
      <div className="orderContainer" style={{ minHeight: _this.state.scaleH }}>
        <CommonNav history={_this.props.history}></CommonNav>
        <div className="pageTitle">确认订单</div>
        <div className="order-course">
          <div className="proxy-image">
            <img src={Api.imageGlobalUrl + _this.state.courseInfo.iconUrl} />
          </div>
          <div className="course-info">
            <p className="auth-info">
              <span className="mr10">{_this.state.courseInfo.expertName}</span>
              <span>{_this.state.courseInfo.position}</span>
            </p>
            <p className="course-name">{_this.state.courseInfo.courseName}</p>
            {/* 书籍价格显示 */}
            <div class="course-price-container">
              <p className="course-price">
                ￥<span>{_this.state.courseInfo.defaultPrice}</span>
              </p>
              <del className="course-old-price">
                ￥<span>{_this.state.courseInfo.oldPrice}</span>
              </del>
            </div>
          </div>
        </div>
        {/* vip优惠显示 */}
        {_this.state.courseInfo.isVip == true && (
          <div className="order-coupon">
            <div className="title">VIP优惠（8折）</div>
            <div className="vip-discount-price">
              -￥
              {this.state.discountPrice.vipDiscountMoney}
            </div>
          </div>
        )}
        {/* 优惠券 */}
        <div className="order-coupon" onClick={_this.couponSelect.bind(_this)}>
          <div className="title">优惠券</div>
          {this.state.isShowCoupnDiscount ? (
            <div className="couponDiscountPrice" style={uiIconCouponSelected}>
              -￥{this.state.discountPrice.couponDiscountMoney}
            </div>
          ) : (
            <div className="coupon" style={uiIconCouponSelect}>
              {_this.state.couponText}
            </div>
          )}
        </div>
        {/* 龙珠 */}
        <div
          className="dragonContainer"
          onClick={_this.troggleDragon.bind(_this)}
        >
          <div className="dragon-info">
            <p className="title">龙珠抵扣</p>
            <p className="dragon">
              余额：{_this.state.dragonInfo.dragonBallCount}
            </p>
          </div>
          <div
            className="dragon-icon"
            style={
              _this.state.isUseDragon
                ? uiIconDragonSelected
                : uiIconDragonSelect
            }
          ></div>
        </div>
        <div className="orderFixedButton">
          {_this.state.shouldPayMoney > 0 && _this.state.isShowPayMoney ? (
            <p className="pay-tips">
              还需支付 <span>￥{_this.state.shouldPayMoney}</span>
            </p>
          ) : (
            <p className="pay-tips"></p>
          )}
          <button className="btn-now" onClick={_this.payNow.bind(_this)}>
            立即支付
          </button>
        </div>
      </div>
    );
  }
  componentWillMount() {
    const _this = this;
    Toast.loading("加载中...", 0, true);
    document.title = "确认订单";
    let courseID = HttpInstance.getSearchByName(
      this.props.location.search,
      "courseID"
    );
    let userInfo = JSON.parse(localStorage.getItem("userInfo"));
    let loginData = localStorage.getItem("loginData");
    if (loginData) {
      loginData = JSON.parse(loginData);
      _this.setState({
        loginData: loginData,
      });
    }
    _this.setState(
      {
        scaleH: window.innerHeight + "px",
        courseID: courseID,
        userInfo: userInfo,
      },
      () => {
        _this.queryCourseInfo();
      }
    );
    // if (userInfo.coupon) {
    //   let text = "";
    //   //   if (userInfo.coupon.couponType && userInfo.coupon.couponType == 1) {
    //   //     text = userInfo.coupon.couponName + " " + userInfo.coupon.money + "元";
    //   //   }
    //   //   if (userInfo.coupon.couponType && userInfo.coupon.couponType == 2) {
    //   //     text =
    //   //       userInfo.coupon.couponName +
    //   //       " " +
    //   //       userInfo.coupon.discount * 10 +
    //   //       "折";
    //   //   }
    //   _this.getPriceBySelectCoupon(userInfo.coupon);
    //   _this.setState({
    //     currentCoupon: userInfo.coupon,
    //     // couponText: text,
    //   });
    // }
    let isApp = HttpInstance.getSearchByName(
      this.props.location.search,
      "isApp"
    );
    let courseInfo = localStorage.getItem("courseInfo");
    courseInfo = JSON.parse(courseInfo);
    console.log("courseInfo", courseInfo);
    if (!isApp) {
      utils.wxShareConfig(
        _this,
        isApp,
        courseID,
        courseInfo.courseName,
        courseInfo.introduction,
        courseInfo.iconUrl
      );
    }
  }
  /**
   * 根据选择的优惠券/龙珠计算价格
   */
  getPriceBySelectCouponAndDragon(selectCoupon) {
    console.log("优惠券是否选择", selectCoupon);
    let params = {};
    let isShowCounponSelect = false;
    params.productId = this.state.courseInfo.productID;
    params.isEnsember = false;
    // 选择优惠券了
    if (JSON.stringify(selectCoupon) !== "{}") {
      params.userCouponId = selectCoupon.id;
      isShowCounponSelect = true;
    }
    params.isUseDragonBall = this.state.isUseDragon;
    let response = HttpInstance.post(Api.QUERY_USECOUPONPRICE_API, params);
    response.then((data) => {
      // console.log(data);
      let discountPricedata = data.data;
      console.log(discountPricedata);
      if (discountPricedata.result) {
        // 显示设置优惠券优惠券金额
        this.setState(
          {
            discountPrice: discountPricedata.data,
            shouldPayMoney: discountPricedata.data.endPrice,
            // selectCoupon: text,
            isShowCoupnDiscount: isShowCounponSelect,
            isVip: discountPricedata.data.isVip,
          },
          () => {
            // 关闭loading
            Toast.hide();
            this.setState({
              isShowPayMoney: true,
            });
            // let money=discountPricedata.data.endPrice;
          }
        );
      } else {
        // 关闭loading
        Toast.hide();
        // 弹出错误信息
        Toast.info(discountPricedata.msg, 1);
      }
    });
  }
  /**
   * 计算金额*/
  computedMoney(obj) {
    let _this = this;
    if (obj) {
      _this = obj;
    }
    let userInfo = _this.state.userInfo;
    let dragon = Number(_this.state.dragonInfo.dragonBallCount);
    let coursePrice = Number(_this.state.courseInfo.productPrice);
    /**
     * 无优惠券无龙珠
     *  */
    if (!_this.state.isUseDragon) {
      _this.setState({
        shouldPayMoney: coursePrice,
      });
    }
    /**
     * 单龙珠结算
     * 默认选择龙珠进行计算
     * 1:如果龙珠的余额足够购买课程,则默认直接扣除龙珠余额
     * 2: 如果龙珠的余额不够购买课程,则默认进行混合支付*/
    if (_this.state.isUseDragon) {
      if (dragon >= coursePrice) {
        _this.setState({
          shouldPayMoney: 0,
        });
      } else {
        let money = coursePrice - dragon;
        money = money.toFixed(2);
        _this.setState({
          shouldPayMoney: money,
        });
      }
    }
    /**
     * 有优惠券有龙珠
     * */
    if (userInfo.coupon.couponType && userInfo.coupon.couponType == 1) {
      if (_this.state.isUseDragon) {
        let money = coursePrice - userInfo.coupon.money;
        money = money.toFixed(2);
        if (dragon >= money) {
          _this.setState({
            shouldPayMoney: 0,
          });
        } else {
          let computedCouponMoney = money - dragon;
          computedCouponMoney = computedCouponMoney.toFixed(2);
          _this.setState({
            shouldPayMoney: computedCouponMoney,
          });
        }
      } else {
        let money = coursePrice - userInfo.coupon.money;
        money = money > 0 ? money : 0.01;
        money = money.toFixed(2);
        _this.setState({
          shouldPayMoney: money,
        });
      }
    }
    if (userInfo.coupon.couponType && userInfo.coupon.couponType == 2) {
      if (_this.state.isUseDragon) {
        let money = coursePrice * userInfo.coupon.discount;
        money = money.toFixed(2);
        if (dragon >= money) {
          _this.setState({
            shouldPayMoney: 0,
          });
        } else {
          let computedMoneyStr = money - dragon;
          computedMoneyStr = computedMoneyStr.toFixed(2);
          _this.setState({
            shouldPayMoney: computedMoneyStr,
          });
        }
      } else {
        let money = coursePrice * userInfo.coupon.discount;
        money = money > 0 ? money : 0.01;
        money = money.toFixed(2);
        _this.setState({
          shouldPayMoney: money,
        });
      }
    }
  }
  /**
   * 获取课程信息
   *  */
  queryCourseInfo() {
    const _this = this;
    let params = {};
    params.courseID = _this.state.courseID;
    let response = HttpInstance.post(Api.QUERY_COURSE_API, params);
    response.then((data) => {
      let responseData = data.data;
      if (responseData.result) {
        let courseInfo = responseData.data;
        _this.setState(
          {
            courseInfo: courseInfo,
            shouldPayMoney: courseInfo.productPrice,
          },
          () => {
            _this.queryCoupons(_this);
          }
        );
      } else {
        // 关闭loading
        Toast.hide();
        // 弹出错误信息
        Toast.info(responseData.msg, 1);
      }
    });
  }
  /**
   * 获取用户龙珠信息-------
   *  */
  queryDragon(obj) {
    const _this = obj;
    let params = {};
    let response = HttpInstance.post(Api.QUERY_DRAGON_API, params);
    response.then((data) => {
      let responseData = data.data;
      if (responseData.result) {
        let dragonInfo = responseData.data;
        // dragonInfo.dragonBallCount=0
        _this.setState(
          {
            dragonInfo: dragonInfo,
          },
          () => {
            // 根据获取龙珠结束之后来判断用户使用龙珠支付不
            let userInfo = JSON.parse(localStorage.getItem("userInfo"));
            // 根据选择的优惠券来计算优惠
            // if (userInfo && userInfo.coupon && userInfo.coupon ) {
            if (
              userInfo &&
              userInfo.coupon &&
              JSON.stringify(userInfo.coupon) !== "{}"
            ) {
              console.log("选择了");
              // 选择优惠券了
              // let text = "";

              //   if (userInfo.coupon.couponType && userInfo.coupon.couponType == 1) {
              //     text = userInfo.coupon.couponName + " " + userInfo.coupon.money + "元";
              //   }
              //   if (userInfo.coupon.couponType && userInfo.coupon.couponType == 2) {
              //     text =
              //       userInfo.coupon.couponName +
              //       " " +
              //       userInfo.coupon.discount * 10 +
              //       "折";
              //   }
              // 根据选择优惠券来设置优惠金额
              _this.getPriceBySelectCouponAndDragon(userInfo.coupon);
              _this.setState({
                currentCoupon: userInfo.coupon,
                // couponText: text,
              });
            } else {
              // 未选择优惠券
              console.log("未选择");
              _this.getPriceBySelectCouponAndDragon({});
            }
            // 关闭loading
            // Toast.hide();
            /**
             * 计算金额
             * */
            // _this.computedMoney(_this);
          }
        );
      } else {
        // 关闭loading
        Toast.hide();
        // 弹出错误信息
        Toast.info(responseData.msg, 1);
      }
    });
  }
  /**
   * 查询优惠券
   */
  queryCoupons(obj) {
    console.log("查询优惠券方法");
    const _this = obj;
    let params = {};
    params.prodId = _this.state.courseInfo.productID;
    params.isEnsemble = false;
    // let params = {};
    // params.status = 0;
    // params.pageIndex = 1;
    // params.pageSize = 10;
    // let response = HttpInstance.post(Api.QUERY_COUPON_API,params);
    let response = HttpInstance.post(Api.QUERY_AVAILABLE_API, params);
    response.then((data) => {
      console.log("获取优惠券", response);
      let responseData = data.data;
      if (responseData.result) {
        let couponList = responseData.data;
        let text = "";
        if (!_this.state.userInfo.coupon.couponType) {
          if (couponList.length > 0) {
            // 查询出来的优惠券数量不为0，此时优惠券状态
            let lock = false;
            for (let i = 0; i < couponList.length; i++) {
              if (couponList[i].available) {
                lock = true;
              }
            }
            text = lock ? "请选择优惠券" : "暂无可用优惠券";
          } else {
            text = "暂无可用优惠券";
          }
          _this.setState({
            couponText: text,
          });
        }
        _this.setState(
          {
            couponList: couponList,
          },
          () => {
            _this.queryDragon(_this);
          }
        );
      } else {
        // 关闭loading
        Toast.hide();
        // 弹出错误信息
        Toast.info(responseData.msg, 1);
      }
    });
  }
  /**
   * 切换龙珠选择
   * */
  troggleDragon() {
    const _this = this;
    Toast.loading("选择中...", 0, true);
    _this.setState(
      {
        isUseDragon: !_this.state.isUseDragon,
      },
      () => {
        // _this.computedMoney(_this);
        // 根据龙珠的选择来计算价格
        let currentCoupon = _this.state.currentCoupon;
        _this.getPriceBySelectCouponAndDragon(currentCoupon);
      }
    );
  }
  /**
   * 选择优惠券
   * */
  couponSelect(item) {
    if (this.state.couponText === '暂无可用优惠券') return
    const _this = this;
    // if (_this.state.couponList.length > 0) {
    //   _this.props.history.push({
    //     pathname: "/coupon",
    //     search: "?productID=" + _this.state.courseInfo.productID,
    //   });
    // } else {
    //   return;
    // }
    // 需求改为有没有优惠券都能点进去
    _this.props.history.push({
      pathname: "/coupon",
      search: "?productID=" + _this.state.courseInfo.productID,
    });
  }
  /**
   * 立即支付*/
  payNow() {
    const _this = this;
    Toast.loading("支付中...", 0, true);
    _this.getPayToken();
  }
  /**
   * 调取支付token
   * */
  getPayToken() {
    let _this = this;
    let params = {};
    let response = null;
    response = HttpInstance.post(Api.QUERY_PAYTOKEN_API, params);

    response.then((data) => {
      let responseData = data.data;
      if (responseData.result) {
        _this.createOrder(responseData.data, _this);
      } else {
        Toast.hide();
      }
    });
  }
  /**
   * 下单
   * */
  createOrder(payToken, obj) {
    const _this = obj;
    let param = {};
    let response = null;
    let loginData = JSON.parse(localStorage.getItem("loginData"));
    param.payType = 1; //微信支付
    param.payToken = payToken;
    // if (_this.state.isUseDragon && _this.state.shouldPayMoney <= 0) {
    // 判断实际需要支付金额是否小于等于0,如果小于等于0的话就走龙珠支付下单
    if (_this.state.shouldPayMoney <= 0) {
      let nonceStr = Math.random(10000);
      //使用龙珠下单
      param.useDragonBall = true;
      param.nonceStr = nonceStr;
      param.productID = _this.state.courseInfo.productID;
      if (
        _this.state.userInfo.coupon &&
        _this.state.userInfo.coupon.couponType
      ) {
        param.couponID = _this.state.userInfo.coupon.couponID;
        // 优惠券领取id
        param.userCouponId = _this.state.userInfo.coupon.id;
      }

      param.signature = _this.createSignatureByDragon(
        _this.state.courseInfo.productID,
        nonceStr
      );
      param.isVip = _this.state.isVip;
      response = HttpInstance.postJSON(Api.CREATE_ORDERBYDRAGON_API, param);
    } else {
      // 实际支付金额大于0----此时判断使用龙珠抵扣了没
      // if(_this.state.isUseDragon && _this.state.shouldPayMoney>0){
      //   // 使用了龙珠支付,并且实际需要支付的金额大于0----使用微信支付

      // }else{
      //   // 未使用龙珠支付,并且实际支付金额大于0----使用微信支付

      // }
      param.productIDs = [];
      param.couponIDs = [];
      // param.userCouponId=[];
      param.productIDs.push(_this.state.courseInfo.productID);
      if (
        _this.state.userInfo.coupon &&
        _this.state.userInfo.coupon.couponType
      ) {
        param.couponIDs.push(_this.state.userInfo.coupon.couponID);
        // 优惠券领取id
        // param.userCouponId.push(_this.state.userInfo.coupon.id);
        param.userCouponId = _this.state.userInfo.coupon.id;
      }
      if (
        _this.state.isUseDragon &&
        _this.state.dragonInfo.dragonBallCount > 0
      ) {
        param.useDragonBall = true;
      } else {
        param.useDragonBall = false;
      }

      param.signature = _this.createSignature(
        _this.state.courseInfo.productID,
        param.payType
      );
      param.isVip = _this.state.isVip;
      response = HttpInstance.postJSON(Api.CREATE_ORDER_API, param);
    }
    response.then((data) => {
      let responseData = data.data;
      console.log("支付信息", responseData);
      if (responseData.result) {
        Toast.hide();
        let orderInfo = responseData.data;
        if (!orderInfo) {
          _this.props.history.go(-1);
        } else {
          window.location.href =
            Api.AUTH_WAYPAY_URL +
            "h5/wxpay.html?orderNo=" +
            orderInfo.orderNo +
            "&openId=" +
            _this.state.loginData.openID +
            "&token=" +
            loginData.accessToken +
            "&payType=1";
        }
      } else {
        Toast.hide();
        setTimeout(() => {
          Toast.info(responseData.msg, 1);
          // 刷新数据
          let userInfo = JSON.parse(localStorage.getItem("userInfo"));
          userInfo.coupon = {};
          localStorage.setItem("userInfo", JSON.stringify(userInfo));
          this.setState(
            {
              userInfo: userInfo,
              currentCoupon: {},
            },
            () => {
              _this.queryCourseInfo();
            }
          );
        }, 1000);
      }
    });
  }
  lineupString(stringArray) {
    if (stringArray.length > 0) {
      stringArray.sort(function (a, b) {
        return a.localeCompare(b);
      });
      return stringArray;
    } else {
      return;
    }
  }
  //生成签名
  createSignatureByDragon(productID, nonceStr) {
    const _this = this;
    let keymap = {
      productID: productID,
      nonceStr: nonceStr,
    };
    let arrayKey = Object.keys(keymap);
    arrayKey = _this.lineupString(arrayKey); //升序排列
    let signUrl = "";
    for (let i = 0; i < arrayKey.length; i++) {
      if (i == 0) {
        signUrl = signUrl + arrayKey[i] + "=" + keymap[arrayKey[i]];
      } else {
        signUrl = signUrl + "&" + arrayKey[i] + "=" + keymap[arrayKey[i]];
      }
    }
    signUrl = HmacSha256(signUrl, "qx8VHRyMkOkHkSFH"); //HmacSHA256加密
    signUrl = Base64.stringify(signUrl); //base64编码
    return signUrl;
  }
  //生成签名
  createSignature(productID, payType) {
    const _this = this;
    let keymap = {
      productIDs: productID,
      payType: payType,
    };
    let arrayKey = Object.keys(keymap);
    arrayKey = _this.lineupString(arrayKey); //升序排列
    let signUrl = "";
    for (let i = 0; i < arrayKey.length; i++) {
      if (i == 0) {
        signUrl = signUrl + arrayKey[i] + "=" + keymap[arrayKey[i]];
      } else {
        signUrl = signUrl + "&" + arrayKey[i] + "=" + keymap[arrayKey[i]];
      }
    }
    signUrl = HmacSha256(signUrl, "qx8VHRyMkOkHkSFH"); //HmacSHA256加密
    signUrl = Base64.stringify(signUrl); //base64编码
    return signUrl;
  }
}
let uiIconCouponSelect = {
  backgroundImage: `url(${iconCouponSelect})`,
};
let uiIconCouponSelected = {
  backgroundImage: `url(${iconCouponSelected})`,
};
let uiIconDragonSelect = {
  backgroundImage: `url(${iconDragonSelect})`,
};
let uiIconDragonSelected = {
  backgroundImage: `url(${iconDragonSelected})`,
};
